module.exports = __webpack_public_path__ + "static/media/luxury.563753b8.png";